// src/components/FooterApercu.jsx
import React, { useContext } from "react";
import { SocieteContext } from "../context/SocieteContext";

export default function FooterApercu() {
  const { infosSociete } = useContext(SocieteContext);
  const html = (infosSociete?.footer_html || "").trim();
  if (!html) return null;

  return (
    <div className="footer-apercu-inner">
      <div
        className="ql-editor !p-0 leading-snug"
        dangerouslySetInnerHTML={{ __html: html }}
      />
      {/* Ligne imaginaire (évite la coupe du dernier pixel à l’export) */}
      <div aria-hidden className="footer-bleed-guard" />
    </div>
  );
}
